module.exports = __webpack_public_path__ + "img/CarF1.91233b2d.svg";